import type { TakeawayPaymentMethod } from "../takeawayTypes"
import { useApiImageUrl } from "../useApiImageUrl"

type TakeawayPaymentMethodIconProps = Readonly<{
    method: TakeawayPaymentMethod
    className: string
}>

export function TakeawayPaymentMethodIcon({ method, className }: TakeawayPaymentMethodIconProps) {
    const resolvedUrl = useApiImageUrl(
        method.icon?.type === "IMAGE_URL" ? method.icon.url : undefined,
    )
    if (method.icon?.type === "IMAGE_URL" && resolvedUrl) {
        return <img src={resolvedUrl} className={className} alt="" />
    }
    return null
}
